// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "account__title-YbqsZ";
var _5 = "account__field-2Voq4";
var _6 = "account__offers-5dbh0";
var _7 = "account__deleteModal-3qEeC";
var _8 = "account__content-3psc3";
var _9 = "social__buttons-30cQf";
var _a = "social__buttons__logo-3qhQQ";
var _b = "social__buttons__wrapper-2ZmiS";
var _c = "social__buttons__control-CHwqi";
var _d = "facebook-1IAUt";
var _e = "twitter-175WG";
var _f = "hidden-1ETVw";
var _10 = "colorSecondary-3BoFh";
var _11 = "deleteButton-Rpyyo";
var _12 = "terms__modal-3-JCW";
var _13 = "loader__wrapper-1A23x";
var _14 = "mui__label-1dcFc";
var _15 = "account__subscription-oFQ6i";
var _16 = "subscription__title-1epx2";
var _17 = "subscription__value-3F1on";
var _18 = "subscription__loader-GZpd-";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "account__title", _5 as "account__field", _6 as "account__offers", _7 as "account__deleteModal", _8 as "account__content", _9 as "social__buttons", _a as "social__buttons__logo", _b as "social__buttons__wrapper", _c as "social__buttons__control", _d as "facebook", _e as "twitter", _f as "hidden", _10 as "colorSecondary", _11 as "deleteButton", _12 as "terms__modal", _13 as "loader__wrapper", _14 as "mui__label", _15 as "account__subscription", _16 as "subscription__title", _17 as "subscription__value", _18 as "subscription__loader" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "account__title": _4, "account__field": _5, "account__offers": _6, "account__deleteModal": _7, "account__content": _8, "social__buttons": _9, "social__buttons__logo": _a, "social__buttons__wrapper": _b, "social__buttons__control": _c, "facebook": _d, "twitter": _e, "hidden": _f, "colorSecondary": _10, "deleteButton": _11, "terms__modal": _12, "loader__wrapper": _13, "mui__label": _14, "account__subscription": _15, "subscription__title": _16, "subscription__value": _17, "subscription__loader": _18 }
